import { render, staticRenderFns } from "./PreviewJobContentSection.vue?vue&type=template&id=bff8c586&scoped=true"
var script = {}
import style0 from "./PreviewJobContentSection.vue?vue&type=style&index=0&id=bff8c586&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff8c586",
  null
  
)

export default component.exports